import { ChevronDownMedium } from '@zoopla-eng/zds-components/icons';
import { fontGroups } from '@zoopla-eng/zds-components/themes/font-groups';
import {
    iconContainerStyle,
    selectWrapperStyle,
    styledLabelStyle,
    styledSelectStyle
} from './Filters.styles.css';

const durations = {
    '900': '15 minutes',
    '1800': '30 minutes',
    '2700': '45 minutes',
    '3600': '1 hour',
    '4500': '1 ¼ hour'
};

const transportTypes = {
    driving: 'Driving',
    walking: 'Walking',
    walking_train: 'Train',
    public_transport: 'Public transport',
    cycling: 'Cycling'
};

type SelectDurationProps = {
    value: string | string[];
    onChange: (duration: string) => void;
};

type SelectTransportTypeProps = {
    value: string | string[];
    onChange: (transportType: string) => void;
};

export const SelectDuration = ({ value, onChange }: SelectDurationProps) => {
    return (
        <div className={selectWrapperStyle}>
            <label
                className={`${styledLabelStyle} ${fontGroups.ladle}`}
                htmlFor="duration"
            >
                Max travel time
            </label>
            <select
                className={`${styledSelectStyle} ${fontGroups.ladle}`}
                id="duration"
                name="duration"
                onChange={(e) => {
                    onChange(e.target.value);
                }}
                value={value}
            >
                {Object.entries(durations).map(([id, text], index) => {
                    return (
                        <option value={id} key={`duration_option_${index}`}>
                            {text}
                        </option>
                    );
                })}
            </select>
            <div className={iconContainerStyle}>
                <ChevronDownMedium />
            </div>
        </div>
    );
};

export const SelectTransportType = ({
    value,
    onChange
}: SelectTransportTypeProps) => {
    return (
        <div className={selectWrapperStyle}>
            <label
                className={`${styledLabelStyle} ${fontGroups.ladle}`}
                htmlFor="transportType"
            >
                Transport type
            </label>
            <select
                className={`${styledSelectStyle} ${fontGroups.ladle}`}
                id="transportType"
                name="transportType"
                onChange={(e) => {
                    onChange(e.target.value);
                }}
                value={value}
            >
                {Object.entries(transportTypes).map(([id, text], index) => {
                    return (
                        <option
                            value={id}
                            key={`transportType_option_${index}`}
                        >
                            {text}
                        </option>
                    );
                })}
            </select>
            <div className={iconContainerStyle}>
                <ChevronDownMedium />
            </div>
        </div>
    );
};
